import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { EppRoutingModule } from './epp-routing.module';
import { ViewEppComponent } from './view-epp/view-epp.component';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddEppComponent } from './add-epp/add-epp.component';
import { MainEppComponent } from './main-epp/main-epp.component';
import {
  NgbDropdownModule,
  NgbTabsetModule,
  NgbAccordionModule,
  NgbCollapseModule,
  NgbModalModule,
  NgbProgressbarModule,
  NgbAlertModule,
  NgbToastModule,
  NgbPopoverModule,
  NgbTooltipModule,
  NgbPaginationModule,
  NgbCarouselModule,
} from '@ng-bootstrap/ng-bootstrap';
import { EditComponent } from './edit/edit.component';
import { RouterModule } from '@angular/router';
import { ViewbyIdComponent } from './viewby-id/viewby-id.component';
import { AddNewComponent } from './add-new/add-new.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { UIModule } from '../shared/ui/ui.module';
import { EditByIdComponent } from './edit-by-id/edit-by-id.component';
import { EditByUseridComponent } from './edit-by-userid/edit-by-userid.component';

@NgModule({
  declarations: [
    ViewEppComponent,
    AddEppComponent,
    MainEppComponent,
    EditComponent,
    ViewbyIdComponent,
    AddNewComponent,
    EditByIdComponent,
    EditByUseridComponent,
  ],
  imports: [
    CommonModule,
    EppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    NgbDropdownModule,
    NgbTabsetModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbModalModule,
    NgbProgressbarModule,
    NgbAlertModule,
    NgbToastModule,
    NgbPopoverModule,
    NgbTooltipModule,
    NgbPaginationModule,
    NgbCarouselModule,
    RouterModule,
    NgSelectModule,
    AutocompleteLibModule,
    UIModule,
  ],
  providers: [DatePipe],
})
export class EppModule {}
